module.exports = __webpack_public_path__ + "static/media/DSC_0178.b649d72b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0178.jpg
// module id = 564
// module chunks = 0